var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpgradePageReminder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#UpgradePageReminder_svg__clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 62,
    height: 88,
    rx: 8,
    fill: "url(#UpgradePageReminder_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#UpgradePageReminder_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#UpgradePageReminder_svg__clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.804,
    y: 26.589,
    width: 48.969,
    height: 65.711,
    rx: 2.093,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.26 43.933c0-.402.325-.727.727-.727H21.95a.727.727 0 110 1.454H10.987a.727.727 0 01-.727-.727zM10.26 54.941c0-.402.325-.727.727-.727h5.52a.727.727 0 110 1.455h-5.52a.727.727 0 01-.727-.728zM37.465 43.933c0-.402.325-.727.727-.727h7.613a.727.727 0 110 1.454h-7.613a.727.727 0 01-.727-.727zM37.465 54.941c0-.402.325-.727.727-.727h10.962a.727.727 0 110 1.455H38.192a.727.727 0 01-.727-.728zM10.408 46.68c0-.463.375-.838.837-.838H21.57c.462 0 .837.375.837.837v3.548a.837.837 0 01-.837.837H11.245a.837.837 0 01-.837-.837v-3.548zM23.383 46.68c0-.463.374-.838.837-.838h9.905c.462 0 .837.375.837.837v3.548a.837.837 0 01-.837.837H24.22a.837.837 0 01-.837-.837v-3.548zM10.26 57.535c0-.286.232-.518.518-.518h23.936a.518.518 0 110 1.036H10.778a.518.518 0 01-.518-.518zM10.26 59.09c0-.286.232-.518.518-.518h23.936a.518.518 0 110 1.036H10.778a.518.518 0 01-.518-.518zM10.26 60.644c0-.286.232-.518.518-.518H27.46a.518.518 0 010 1.036H10.778a.518.518 0 01-.518-.518z",
    fill: "#E6EBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.26 62.198c0-.286.232-.518.518-.518h23.936a.518.518 0 110 1.036H10.778a.518.518 0 01-.518-.518zM10.26 63.752c0-.286.232-.518.518-.518h10.466a.518.518 0 110 1.037H10.778a.518.518 0 01-.518-.519z",
    fill: "#FFD1E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.615,
    y: 57.017,
    width: 13.056,
    height: 4.248,
    rx: 0.837,
    fill: "#E6EBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.615,
    y: 61.784,
    width: 13.056,
    height: 2.487,
    rx: 1.243,
    fill: "#E6EBEB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#UpgradePageReminder_svg__filter1_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.512,
    y: 46.33,
    width: 3.73,
    height: 3.73,
    rx: 1.865,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#UpgradePageReminder_svg__filter2_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.279,
    y: 46.365,
    width: 3.73,
    height: 3.73,
    rx: 1.865,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#UpgradePageReminder_svg__filter3_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.941,
    y: 46.365,
    width: 3.73,
    height: 3.73,
    rx: 1.865,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.408,
    y: 67.188,
    width: 24.694,
    height: 26.368,
    rx: 1.658,
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.245,
    y: 72.21,
    width: 22.892,
    height: 4.611,
    rx: 1.243,
    fill: "#E6EBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 77.479,
    width: 22.892,
    height: 4.611,
    rx: 1.243,
    fill: "#E6EBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 82.92,
    width: 22.892,
    height: 4.611,
    rx: 1.243,
    fill: "#E6EBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.515 69.589c0-.402.326-.728.728-.728h9.287a.727.727 0 110 1.455h-9.287a.727.727 0 01-.728-.727z",
    fill: "#DAE3E3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#UpgradePageReminder_svg__clip2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.195,
    y: 67.188,
    width: 13.393,
    height: 26.368,
    rx: 1.658,
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.922,
    y: 72.122,
    width: 5.441,
    height: 7.952,
    rx: 1.243,
    fill: "#E6EBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.922,
    y: 80.911,
    width: 5.441,
    height: 7.952,
    rx: 1.243,
    fill: "#E6EBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.2,
    y: 72.122,
    width: 5.441,
    height: 7.952,
    rx: 1.243,
    fill: "#E6EBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.2,
    y: 80.911,
    width: 5.441,
    height: 7.952,
    rx: 1.243,
    fill: "#E6EBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.191 69.502c0-.402.326-.728.728-.728h8.45a.727.727 0 010 1.455h-8.45a.727.727 0 01-.728-.727z",
    fill: "#DAE3E3"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.804 26.589h49.013v13.79H5.804v-13.79z",
    fill: "url(#UpgradePageReminder_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.571,
    y: 28.264,
    width: 9.626,
    height: 9.626,
    rx: 0.837,
    fill: "#3B4142",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.709,
    y: 29.938,
    width: 25.964,
    height: 2.107,
    rx: 1.054,
    fill: "#3B4142",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.709,
    y: 33.704,
    width: 17.174,
    height: 2.107,
    rx: 1.054,
    fill: "#3B4142",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#UpgradePageReminder_svg__filter4_dd)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.436,
    cy: 40.153,
    r: 1.743,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#UpgradePageReminder_svg__filter5_dd)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.929,
    cy: 40.153,
    r: 1.743,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M67.7 37.829c-7.863 0-10.303 2.44-10.303 10.304 0-7.864-2.577-10.304-10.304-10.304 7.863 0 10.303-2.44 10.303-10.304 0 7.863 2.44 10.304 10.304 10.304zM29.725 14.316c-6.728 0-8.816 2.088-8.816 8.817 0-6.729-2.204-8.817-8.816-8.817 6.728 0 8.816-2.088 8.816-8.816 0 6.728 2.088 8.816 8.816 8.816zM53.725 15.291c-1.386 0-1.816.43-1.816 1.817 0-1.386-.454-1.817-1.816-1.817 1.386 0 1.816-.43 1.816-1.816 0 1.386.43 1.816 1.816 1.816zM12.44 25.706c-3.52 0-4.614 1.161-4.614 4.903 0-3.742-1.153-4.903-4.614-4.903 3.521 0 4.614-1.161 4.614-4.903 0 3.742 1.093 4.903 4.615 4.903zM12.868 88.604c-7.507 0-9.836 2.33-9.836 9.835 0-7.506-2.46-9.835-9.836-9.835 7.506 0 9.836-2.33 9.836-9.836 0 7.506 2.33 9.836 9.836 9.836z",
    fill: "#FFF9EB",
    stroke: "#FFD368",
    strokeWidth: 0.837,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.326 22.082h0a2.536 2.536 0 00-1.836-.8c-.684 0-1.345.285-1.836.8h3.672zm0 0l.886.93.303.317m-1.19-1.247l1.19 1.247m0 0l.303-.318m-.303.318l.303-.318m0 0l.887-.93h0m-.887.93l.887-.93m0 0l.005-.005m-.005.006l.005-.006m0 0c.241-.262.529-.47.846-.613a2.483 2.483 0 012.002-.019c.319.137.61.34.856.598.246.258.441.566.574.906a2.894 2.894 0 01-.018 2.146 2.766 2.766 0 01-.589.895h0m-3.671-3.913l3.671 3.913m0 0l-.005.006m.005-.006l-.005.006m0 0l-4.558 4.785m4.558-4.785l-4.558 4.785m0 0a.418.418 0 01-.606 0m.606 0h-.606m0 0l-4.558-4.785m4.558 4.785l-4.558-4.785m0 0a2.839 2.839 0 01-.77-1.957c0-.737.28-1.44.77-1.957v3.914zM45.224 76.57h0a.695.695 0 00-.507-.226.695.695 0 00-.506.226h1.013zm0 0l.336.357.305.325m-.642-.682l.642.682m0 0l.304-.325m-.304.325l.304-.325m0 0l.337-.357h0m-.337.357l.337-.357m0 0l.005-.006m-.005.006l.005-.006m0 0a.73.73 0 01.236-.174.67.67 0 01.547-.005c.087.038.169.095.239.17.07.074.126.164.165.264l.39-.15m-1.577-.105l1.577.105m0 0l-.39.15a.872.872 0 01-.005.638l.388.157-.389-.157a.809.809 0 01-.169.261h0m.565-1.049l-.565 1.05m0 0l-.005.005m.005-.006l-.005.006m0 0l-1.348 1.435m1.348-1.435l-1.348 1.435m0 0a.419.419 0 01-.61 0m.61 0h-.61m0 0l-1.35-1.435m1.35 1.435l-1.35-1.435m0 0s0 0 0 0m0 0h0m0 0a.844.844 0 01-.222-.577m.223.577l-.223-.577m0 0c0-.221.083-.428.223-.577l-.223.577zM56.537 73.763h0a3.226 3.226 0 00-4.57 0h4.57zm0 0l1.07 1.073.296.297m-1.366-1.37l1.366 1.37m0 0l.297-.297m-.297.297l.297-.297m0 0l1.07-1.073h0m-1.07 1.073l1.07-1.073m0 0l.005-.005m-.005.005l.005-.005m0 0a3.232 3.232 0 012.296-.99 3.222 3.222 0 012.314.95 3.246 3.246 0 01.947 2.323 3.257 3.257 0 01-.987 2.307h0m-4.57-4.59l4.57 4.59m0 0l-.005.005m.005-.005l-.005.005m0 0l-5.64 5.661m5.64-5.66l-5.64 5.66m0 0a.419.419 0 01-.593 0m.593 0h-.593m0 0l-5.64-5.66m5.64 5.66l-5.64-5.66m0 0s0 0 0 0m0 0h0m0 0a3.253 3.253 0 01-.947-2.296m.947 2.295l-.947-2.295m0 0c0-.861.341-1.687.947-2.295l-.947 2.295zM5.719 46.646h0a1.893 1.893 0 00-1.38-.61c-.512 0-1.008.216-1.379.61H5.72zm0 0l.698.743.305.324m-1.003-1.067l1.003 1.067m0 0l.304-.324m-.304.324l.304-.324m0 0l.698-.743h0m-.698.743l.698-.743m0 0l.005-.005m-.005.005l.005-.005m0 0c.183-.201.4-.36.638-.469a1.839 1.839 0 011.501-.014c.24.104.459.26.644.457.186.197.334.434.435.696a2.26 2.26 0 01-.013 1.654c-.105.26-.257.494-.446.688h0m-2.759-3.012l2.759 3.012m0 0l-.005.006m.005-.006l-.005.006m0 0l-3.456 3.68m3.456-3.68l-3.456 3.68m0 0a.419.419 0 01-.61 0m.61 0h-.61m0 0l-3.457-3.68m3.456 3.68l-3.456-3.68m0 0a2.203 2.203 0 01-.584-1.507c0-.57.213-1.11.584-1.506v3.013z",
    fill: "#F399AA",
    stroke: "#EF5C84",
    strokeWidth: 0.837
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "UpgradePageReminder_svg__filter0_d",
    x: -2.148,
    y: 21.148,
    width: 64.874,
    height: 81.615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.511
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.976
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "UpgradePageReminder_svg__filter1_dd",
    x: 37.135,
    y: 46.047,
    width: 4.483,
    height: 4.672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.282
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.188
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.094
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.094
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.101399 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "UpgradePageReminder_svg__filter2_dd",
    x: 41.902,
    y: 46.083,
    width: 4.483,
    height: 4.672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.282
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.188
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.094
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.094
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.101399 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "UpgradePageReminder_svg__filter3_dd",
    x: 46.564,
    y: 46.083,
    width: 4.483,
    height: 4.672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.282
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.188
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.094
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.094
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.101399 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "UpgradePageReminder_svg__filter4_dd",
    x: 42.397,
    y: 38.188,
    width: 4.079,
    height: 4.227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.148
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.074
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.074
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.101399 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "UpgradePageReminder_svg__filter5_dd",
    x: 46.89,
    y: 38.188,
    width: 4.079,
    height: 4.227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.148
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.074
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.074
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.232444 0 0 0 0 0.254987 0 0 0 0 0.260077 0 0 0 0.101399 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "UpgradePageReminder_svg__clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 62,
    height: 88,
    rx: 8,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "UpgradePageReminder_svg__clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.804,
    y: 26.589,
    width: 48.969,
    height: 65.711,
    rx: 2.093,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "UpgradePageReminder_svg__clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.195,
    y: 67.188,
    width: 13.393,
    height: 26.368,
    rx: 1.658,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "UpgradePageReminder_svg__paint0_linear",
    x1: 0.678,
    y1: 87.775,
    x2: 83.332,
    y2: 29.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E66924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#F5893D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#F5893D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "UpgradePageReminder_svg__paint1_linear",
    x1: 5.804,
    y1: 40.379,
    x2: 12.994,
    y2: 14.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#41CBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#41CBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03D0C4"
  })))));
}

export default SvgUpgradePageReminder;